import script from "./list-layout-two.vue?vue&type=script&setup=true&lang=js"
export * from "./list-layout-two.vue?vue&type=script&setup=true&lang=js"

import "./list-layout-two.vue?vue&type=style&index=0&id=06eb85d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06eb85d6"]])

export default __exports__